/**
 * 施設タイプ
 */
export default class PlaceType {
  /**
   *
   * @param {Array} placeTypes
   * @param {Object=} options
   */
  constructor(placeTypes, options) {
    this.reset(placeTypes, options);
  }
  /**
   *
   * @param type_id
   * @returns {*}
   */
  getTypeIcon(type_id){
    
    // ファセット検索の場合、各タイプファセットのアイコンを返す
    if (this.facet_type_icon_min_table.length !== 0) {
      return this.icon_file_path + this.facet_type_icon_min_table[type_id];
    }
    if (this.facet_type_icon_pin_table.length !== 0) {
      return this.icon_file_path + this.facet_type_icon_pin_table[type_id];
    }
    
    // カテゴリ検索の場合、各カテゴリアイコンを返す
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_min){
      return this.icon_file_path + this.placeTypes[type_id].icon_min;
    }
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_pin){
      return this.icon_file_path + this.placeTypes[type_id].icon_pin;
    }
    
    return this.icon_default;
    
  }
  /**
   *
   * @param type_id
   * @returns {*}
   */
  getMarkerIcon(type_id){
  
    // ファセット検索の場合、各タイプファセットのマーカを返す
    if (this.facet_type_icon_pin_table.length !== 0 && this.facet_type_icon_pin_table[type_id]) {
      return this.icon_file_path + this.facet_type_icon_pin_table[type_id];
    }
  
    // カテゴリ検索の場合、各カテゴリアのマーカを返す
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_pin){
      return this.icon_file_path + this.placeTypes[type_id].icon_pin;
    }
    
    return this.icon_default;
    
  }
  getName(type_id) {
    
    // カテゴリ検索の場合、カテゴリ項目名を返す
    if (this.facet_type_name_table.length === 0) {
      
      return this.facility_type_name_table[type_id];
      
    // ファセット検索の場合、タイプファセット名を返す
    } else {
      
      return this.facet_type_name_table[type_id];
      
    }
    
  }
  getAll() {
    return this.placeTypes;
  }
  /**
   * 外から設定し直したい場合
   * 
   */
  reset(placeTypes, options) {
    
    this.placeTypes = placeTypes;
    this.icon_default = options.icon_default;
    this.icon_file_path = options.icon_file_path;
    this.facility_type_name_table = [];
  
    // タイプファセット専用テーブル (名称、アイコン)
    this.facet_type_name_table = [];
    this.facet_type_icon_min_table = [];
    this.facet_type_icon_pin_table = [];
    
    for (let i = 0; i < placeTypes.length; i++) {
      
      let place = placeTypes[i];
      
      this.facility_type_name_table.push(place.name);
      
      // ファセット検索にて、対象がタイプファセットの場合、専用テーブルに名称・アイコンをセット
      if (place.type_facet) {
        this.facet_type_name_table.push(place.name);
        this.facet_type_icon_min_table.push(place.icon_min);
        this.facet_type_icon_pin_table.push(place.icon_pin);
      }
    }
    
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/PlaceType.js